<template>
    <div>
        
        <div class="row head">
<!--            <div class="col col-100">Nieuw support ticket</div>-->
        </div>
        <div class="row spacer">&nbsp;</div>

        <div class="row setting row-first" v-bind:class="{'setting--nb': $root.app.platform == 'android'}">
            <div v-if="$root.app.platform == 'android'" class="col col-100">
                <span class="row__title">Onderwerp</span><br/>
                <div class="select-wrap">
                    <input v-model="form.subject" type="text" name="subject" placeholder="Stel je vraag" @input="$v.form.subject.$touch()"/>
                    <span class="select-arrow"></span>
                </div>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <span class="row__title">Onderwerp</span>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <input v-model="form.subject" type="text" name="subject" placeholder="Stel je vraag" @input="$v.form.subject.$touch()"/>
            </div>
        </div>
        
        <div class="row row-last setting">
            <div class="col col-100">
                <div class="form-group" v-bind:class="{ 'form-group--error': $v.form.message.$error }">
                    <textarea class="form__input form__textarea" type="text" placeholder="Typ hier je bericht" v-model="form.message" @input="$v.form.message.$touch()"></textarea>
                </div>
            </div>
        </div>
        
        <div v-if="$root.app.platform == 'ios'" class="row spacer">&nbsp;</div>
        
        <div v-if="$root.app.platform == 'android'" class="row row-button">
            <div class="col col-100" @click="submit()">
                <button class="button">Ticket versturen</button>
            </div>
            <span class="form-group__message" v-if="!$v.form.message.required">Veld is verplicht</span>
            <span class="form-group__message" v-if="!$v.form.message.minLength">Bericht dient minimaal {{$v.form.message.$params.minLength.min}} tekens te bevatten.</span>
        </div>
        
        <div v-if="$root.app.platform == 'ios'" class="row row-last setting">
            <div class="col col-100" @click="submit()">
                <button class="button">Ticket versturen</button>
            </div>
            <span class="form-group__message" v-if="!$v.form.message.required">Veld is verplicht</span>
            <span class="form-group__message" v-if="!$v.form.message.minLength">Bericht dient minimaal {{$v.form.message.$params.minLength.min}} tekens te bevatten.</span>
        </div>
        <div v-if="$root.app.platform == 'ios'" class="row spacer">&nbsp;</div>
        
<!--        <div class="form-group" v-bind:class="{ 'form-group--error': $v.form.message.$error }">
            <label class="form__label">Bericht</label>
            <textarea class="form__input" type="text" v-model="form.message" @input="$v.form.message.$touch()"></textarea>
        </div>
        <span class="form-group__message" v-if="!$v.form.message.required">Field is required</span>
        <span class="form-group__message" v-if="!$v.form.message.minLength">Message must have at least {{$v.form.message.$params.minLength.min}} letters.</span>
        <div class="form-group" v-bind:class="{ 'form-group--error': $v.form.message.$error }">
            <button @click="submit()">Versturen</button>
        </div>-->
        
    </div>
</template>

<script>
    
    import { required, minLength, numeric } from 'vuelidate/lib/validators'
    
    export default {
        data () {
            
            return {
                form: [],
            }
        },
        
        validations: {
            form:{
                subject:{
                    required,
                    minLength: minLength(10)
                },
                message:{
                    required,
                    minLength: minLength(10)
                },
            }
        },
        
        mounted(){
            
        },
        
        created(){
            
            this.$api.get('/tickets/options')
            .catch(e => {
                
                _this.$root.ui.showDialog(
                    'Fout',
                    'There was an error creating your ticket.',
                    true
                );
            })
        },
        
        methods:{
            submit(){
                
                this.$root.loading = true;
                
                var form = this.form;
                
                this.$api.post('/tickets', {
                    subject: form.subject,
                    category: form.category,
                    message: form.message
                })
                .then(response => {
                    
                    this.$router.go(-1); //Back to /feedback
                    this.$root.loading = false;
                })
                .catch(e => {
                    console.log(e.response.data.message.message);
                    this.$root.loading = false;
                     this.$root.ui.showDialog(
                        'Fout',
                        e.response.data.message.message,
                        true
                    );

                    // this.$root.ui.showDialog(
                    //     'Fout',
                    //     'Er was een probleem tijdens het aanmaken van uw ticket.',
                    //     true
                    // );
                })
            },
            
            changedValue(){
                
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/tickets/Create.vue